import { render } from "./EventList.vue?vue&type=template&id=c12066da&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=c12066da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c12066da"

export default script